import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { CloseIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { useClosePetition } from './hooks/useClosePetition';

export const ClosePetition: React.FC = () => {
	const {
		actions: { handleClosePetition },
	} = useClosePetition();

	return (
		<>
			<div className="flex w-full flex-col">
				<Text className="mt-6" size="x-small" variant="heading">
					<Translate value="corgi.petition.edit.settings.close_petition.button" />
				</Text>
				<Text className="mt-3" variant="body">
					<Translate value="corgi.petition.edit.settings.close_petition.description" />
				</Text>
			</div>
			<div>
				<Button
					className="sm:mt-4 sm:w-full md:mt-8 md:w-max"
					leadingIcon={<CloseIcon />}
					variant="secondary"
					size="small"
					data-qa="close-petition-button"
					onClick={handleClosePetition}
				>
					<Translate value="corgi.petition.edit.settings.close_petition.button" />
				</Button>
			</div>
		</>
	);
};
